import store from "@/store/index.js";
import { collection, getDocs, query, where } from "firebase/firestore";
import { COLLECTION_USER_FRANQUEADO } from "./collectionsNames.js";
import { db } from "./firebase.js";

export const getUserFranqueadoByTotemId = async () => {
  let totemID = store.getters["totem/getTotem"].id;
  let ref = collection(db, COLLECTION_USER_FRANQUEADO);
  let q = query(ref, where("totemID", "==", totemID));

  const querySnapshot = await getDocs(q);

  let franqueados = [];
  querySnapshot.forEach((doc) => {
    franqueados.push({
      totemID: doc.data().totemID,
      userID: doc.data().userID,
    });
  });

  if (franqueados.length === 0) {
    return {
      franqueados: [],
      message: "Nenhum franqueado encontrado para o totemID fornecido.",
      error: true,
    };
  }

  if (franqueados.length > 0) {
    return {
      franqueados: franqueados,
      error: false,
    };
  }
};
